export type MaterialCategory = 'requirements' | 'standards' | 'rules' | 'general';

export interface Material {
  id: string;
  assistant_id: string;
  organization_id: string;
  title: string;
  content: string;
  category: MaterialCategory;
  sort_order: number;
  tags: string[];
  created_by?: string;
  created_at: string;
  updated_at: string;
  deleted_at?: string;
}

/** Материал в корзине направления (GET .../materials/trash) */
export interface DeletedMaterial extends Material {
  deleted_at: string;
  deleted_by_name?: string;
  purge_at: string;
}

export interface CreateMaterialRequest {
  title: string;
  content: string;
  category: MaterialCategory;
  tags?: string[];
  sort_order?: number;
}

export interface UpdateMaterialRequest {
  title: string;
  content: string;
  category: MaterialCategory;
  tags?: string[];
  sort_order?: number;
}

export const CATEGORY_CONFIG: Record<MaterialCategory, { label: string; icon: string }> = {
  requirements: { label: 'Требования', icon: '🎯' },
  standards: { label: 'Нормативы', icon: '📊' },
  rules: { label: 'Правила', icon: '📋' },
  general: { label: 'Общее', icon: '📄' },
};
